import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Pop-up automatique affichée dès qu'une nouvelle version (Service Worker) est
 * détectée. Indépendante des notifications : déclenchée par l'événement
 * 'mibeko:update-available' émis par le cycle de vie du SW (voir public/index.html,
 * qui vérifie les mises à jour au chargement, toutes les 60s et au retour sur l'app).
 * Clic "Mettre à jour" → SKIP_WAITING → le SW s'active → la page se recharge.
 */
const UpdateBanner = () => {
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    const onUpdate = (e) => setWaiting(e.detail?.waiting || null);
    window.addEventListener('mibeko:update-available', onUpdate);
    return () => window.removeEventListener('mibeko:update-available', onUpdate);
  }, []);

  if (!waiting) return null;

  const apply = () => {
    try {
      waiting.postMessage({ type: 'SKIP_WAITING' });
      // Filet de sécurité si le SW ne prend pas la main
      setTimeout(() => window.location.reload(), 1500);
    } catch (err) {
      window.location.reload();
    }
  };

  return (
    <div className="update-modal-overlay" role="dialog" aria-modal="true" data-testid="update-banner">
      <div className="update-modal">
        <div className="update-modal-icon" aria-hidden>
          <RefreshCw style={{ width: 30, height: 30 }} />
        </div>
        <h2 className="update-modal-title">Mise à jour disponible</h2>
        <p className="update-modal-sub">
          Une nouvelle version de Mibeko est prête, avec les dernières lois et améliorations.
          Mettez à jour maintenant pour en profiter.
        </p>
        <button
          className="update-modal-cta"
          onClick={apply}
          data-testid="update-banner-apply"
        >
          <RefreshCw style={{ width: 18, height: 18 }} />
          Mettre à jour maintenant
        </button>
        <button
          className="update-modal-later"
          onClick={() => setWaiting(null)}
          data-testid="update-banner-close"
        >
          Plus tard
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
